export const COLORS = {
  primary: '#2196F3',
  primaryDark: '#1976D2',
  secondary: '#FFC107',
  accent: '#E91E63',
  success: '#00c853',
  danger: '#ef5350',
  text: '#333333',
  textLight: '#999999',
  bg: '#f4f6f9',
  grey: '#607D8B',
  white: '#ffffff',
};